export default __webpack_public_path__ + "i18n/uk.084e58cd8368e5aff6eb369b5c9073b8.json";